import { Action } from 'redux';

import {
  OpenAttachPopupArgs,
  ResultDetailsAction,
  ResultDetailsActionConstants,
  ResultDetailsState,
  SelectGroupTabArgs,
  SetAttachListArgs,
  SetResultDetailsArgs,
} from './types';

export const initialState: ResultDetailsState = {
  networkStates: {
    resultDetailsRequest: {
      isRequesting: false,
    },
    attachListRequest: {
      isRequesting: false,
    },
  },
  isInitialized: false,
  groupSelected: {
    formId: 0,
    formCode: '',
    formName: '',
    formFile: '',
    langIndex: '',
  },
  attachListPopup: {
    isOpen: false,
  },
  testListPopup: {
    isOpen: false,
  },
};

export default function resultDetailsReducer(
  state = initialState,
  action: Action<ResultDetailsActionConstants>,
): ResultDetailsState {
  switch (action.type) {
    case ResultDetailsActionConstants.INITIALIZE: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case ResultDetailsActionConstants.RESULT_DETAILS_REQUEST: {
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          resultDetailsRequest: {
            ...state.networkStates.resultDetailsRequest,
            isRequesting: true,
          },
        },
      };
    }
    case ResultDetailsActionConstants.RESULT_DETAILS_SET: {
      const act = (action as ResultDetailsAction<SetResultDetailsArgs>);
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          resultDetailsRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
        resultDetails: act.resultDetails,
      };
    }
    case ResultDetailsActionConstants.SELECT_GROUP_TAB_SET: {
      const act = (action as ResultDetailsAction<SelectGroupTabArgs>);
      return {
        ...state,
        groupSelected: act.tab,
      };
    }
    case ResultDetailsActionConstants.TEST_LIST_POPUP_OPEN: {
      return {
        ...state,
        testListPopup: {
          isOpen: true,
        },
      };
    }
    case ResultDetailsActionConstants.TEST_LIST_POPUP_CLOSE: {
      return {
        ...state,
        testListPopup: {
          isOpen: false,
        },
      };
    }
    case ResultDetailsActionConstants.ATTACH_LIST_POPUP_OPEN: {
      const act = (action as ResultDetailsAction<OpenAttachPopupArgs>);
      return {
        ...state,
        attachListPopup: {
          isOpen: true,
          resultDetailId: act.resultDetailId,
        },
      };
    }
    case ResultDetailsActionConstants.ATTACH_LIST_POPUP_CLOSE: {
      return {
        ...state,
        attachListPopup: {
          isOpen: false,
          resultDetailId: undefined,
        },
        attachList: undefined,
      };
    }
    case ResultDetailsActionConstants.ATTACH_LIST_REQUEST: {
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          attachListRequest: {
            ...state.networkStates.attachListRequest,
            isRequesting: true,
          },
        },
      };
    }
    case ResultDetailsActionConstants.ATTACH_LIST_SET: {
      const act = (action as ResultDetailsAction<SetAttachListArgs>);
      return {
        ...state,
        networkStates: {
          ...state.networkStates,
          attachListRequest: {
            isRequesting: false,
            lastError: act.error,
          },
        },
        attachList: act.result,
      };
    }
    default:
      return state;
  }
}
